import { Button } from "../../../../components/core/Button";
import { Modal } from "../../../../components/others/Modal/index";

type TProps = {
    toggleModal: boolean;
    urlTittle: string;
    handleClick: Function;
};

const AcceptedPass = ({ toggleModal, urlTittle, handleClick }: TProps) => {

    return (
        <>
            <Modal
                show={toggleModal}
                urlTittle={urlTittle}
                modalContainerStyle={"w-auto m-[auto] flex justify-center"}
                onClose={()=> handleClick && handleClick()}
            >
                <h1 className="w-auto m-[auto] flex justify-center">Tu contraseña se creó con éxito</h1>
                <p className="w-auto m-[auto] flex justify-center">Ya puedes ingresar con tus nuevas credenciales.</p>
                <Button
                    type="button"
                    text="Ir al Portal"
                    onClick={() => handleClick && handleClick()}
                    className="w-auto m-[auto] flex justify-center bg-red-500 mt-5 text-white"
                />
            </Modal>
        </>
    );
};

export default AcceptedPass;
